import { lastGridRouteEntity } from './lastGridRouteEntity';
import { LocationDescriptorObject, Path } from 'history';
import { requestedEntity } from './requestedEntity';
import { Route, RouteType } from 'module/Model/Routes';
import { push } from '@etienne-dldc/redux-router-location';
import { PromiseUtils, nn } from 'module/Common';
import { Dispatchable, dispatchable, State } from 'module/Redux';
import { RouterSelector } from 'module/Redux/Router/RouterSelector';

export namespace RouterAction {
  export const setLastGridRoute = (route: Route) => lastGridRouteEntity.actionCreators.set(route);

  export const imediateNavigation = (path: string, search: string) =>
    push({
      pathname: path,
      search,
    });

  export const requestNavigation = (path: string, search: string): Dispatchable =>
    dispatchable([
      setRequestedRoute({ pathname: path, search }),
      s => {
        const currentRoute = RouterSelector.selectMatchingRoute(s);
        const requestedRoute = RouterSelector.selectRequestedMatchingRoute(s);
        const delay: number = (() => {
          if (requestedRoute === null) {
            return 600;
          }
          const currentIsGrid = currentRoute.type === RouteType.Home || currentRoute.type === RouteType.Category;
          const requestedIsGrid = requestedRoute.type === RouteType.Home || requestedRoute.type === RouteType.Category;
          if (currentIsGrid && requestedIsGrid) {
            return 0;
          }
          return 600;
        })();
        return PromiseUtils.wait(delay).then(() => {
          return (state: State): Dispatchable => {
            const location = RouterSelector.selectRequested(state).location;
            if (location !== null && location.pathname === path && location.search === search) {
              // scoll to top
              nn(document.documentElement).scrollTop = 0;
              document.body.scrollTop = 0;
              return requestedEntity.actionCreators.isReady(null);
            }
            console.info('cancel navigation');
            console.info({ location, path, search });
            return null;
          };
        });
      },
    ]);

  export const setRequestedRoute = (location: Path | LocationDescriptorObject) =>
    requestedEntity.actionCreators.set(location);
  export const resetRequestedRoute = () => requestedEntity.actionCreators.reset(null);
}



// WEBPACK FOOTER //
// ./src/module/Redux/Router/RouterAction.ts